import { FC } from 'react';
import {
  WbCard,
  WbCardContent,
  WbDockableGroup,
  WbDockablePanel,
  WbDockableResizeHandle,
  WbTabsListContext,
} from '@agilelab/plugin-wb-platform';
import { makeStyles, useTheme } from '@material-ui/core';
import { DescriptorCard } from './DescriptorCard';
import { EditorCardActions } from './EditorCardActions';
import { StructureCard } from './StructureCard/StructureCard';
import { DescriptorCardActions } from './DescriptorCardActions';
import { useEditorPageContext } from '../context/useEditorPageContext';

const useStyles = makeStyles(
  theme => ({
    card: {
      height: '100%',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        overflow: 'visible',
      },
    },
    structureContent: {
      height: '100%',
      overflow: 'hidden',
      padding: theme.spacing(1.5),
      width: '100%',
      display: 'flex',
    },
    dockableGroup: {
      minHeight: 0,
      minWidth: 0,
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        minHeight: 400,
        overflow: 'visible',
      },
    },
    descriptorContent: {
      height: '100%',
      overflow: 'hidden',
      padding: theme.spacing(1.5),
      width: '100%',
    },
  }),
  { name: 'EditorCard' },
);

export const EditorCard: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { currentDescriptorViewMode, setDescriptorViewModeOverride } =
    useEditorPageContext();

  return (
    <WbCard
      title="Editor"
      cardClassName={classes.card}
      actions={<EditorCardActions />}
    >
      <WbTabsListContext
        value={currentDescriptorViewMode}
        onValueChange={v =>
          setDescriptorViewModeOverride(v as 'customView' | 'yaml')
        }
      >
        <WbDockableGroup
          className={classes.dockableGroup}
          direction="horizontal"
        >
          <WbDockablePanel
            defaultSize={35}
            maxSize={50}
            title="Structure"
            showCollapsedContent
            cardHeaderStyles={{ minHeight: '40px' }}
          >
            <WbCardContent className={classes.structureContent}>
              <StructureCard />
            </WbCardContent>
          </WbDockablePanel>

          <WbDockableResizeHandle
            showIconOnHover
            divider
            direction="horizontal"
          />

          <WbDockablePanel
            minSize={25}
            defaultSize={65}
            title="Descriptor"
            headerActions={<DescriptorCardActions />}
            headerBorderBottom
          >
            <WbCardContent
              className={classes.descriptorContent}
              style={
                currentDescriptorViewMode === 'customView'
                  ? {
                      padding: 0,
                      backgroundColor: theme.palette.background.paper,
                    }
                  : undefined
              }
            >
              <DescriptorCard />
            </WbCardContent>
          </WbDockablePanel>
        </WbDockableGroup>
      </WbTabsListContext>
    </WbCard>
  );
};
